import { styled } from 'styled-components';

import { verticalFadeIn, verticalFadeOut } from '../../../theme/animations.ts';
import { ANIMATION_DURATION_MS } from './constants.ts';

interface WrapperProps {
  $zIndex: number;
  $isTop: boolean;
  $visible: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  z-index: ${({ $zIndex }) => $zIndex};
  ${({ theme }) => theme.shadows.large};
  border-radius: 8px;
  animation: ${({ $isTop, $visible }) => ($visible ? verticalFadeIn($isTop) : verticalFadeOut($isTop))} ${ANIMATION_DURATION_MS}ms ease
    forwards;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;

interface InnerWrapperProps {
  $minWidth: boolean;
  $zIndex: number;
}

export const InnerWrapper = styled.div<InnerWrapperProps>`
  border-radius: 8px;
  list-style: none;
  background: ${({ theme }) => theme.colors.grey00_6};
  z-index: ${({ $zIndex }) => $zIndex};
  min-width: ${({ $minWidth }) => $minWidth && '160px'};
  overflow: hidden;
  position: relative;
`;

export const ButtonWrapper = styled.div`
  display: grid;
`;
